const ROUTES = {
  highScores: '/highscores',
  home: '/',
  snake: '/snake',
};

export default ROUTES;
